import type { UrlButtonStyle } from "../types"

/** Runtime allowlist for source validation, UI selection and wire boundaries. */
export function isUrlButtonStyle(value: unknown): value is UrlButtonStyle {
  return value === "primary" || value === "success" || value === "danger"
}

// Keep aligned with telegramPreview.css. These are Telegram colors, not MUI's
// host palette (whose primary may be red). All have >= 4.5:1 contrast with white.
export const urlButtonColors: Record<UrlButtonStyle, string> = {
  primary: "#1565c0",
  success: "#2e7d32",
  danger: "#c62828",
}
